import Radium from 'radium';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Waves from 'node-waves';
import { Scrollbars } from 'react-custom-scrollbars';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import DatepickerSmall from '../../../Common/datepickerSmall';
import Employee from './employee';
import SuggestSelectInput from '../../../Common/suggestSelectInput'
import EmployeeDropableTrashcan from '../../../Common/employeeDropableTrashcan';
import EmployeeDropableSorter from './employeeDropableSorter';

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
			currentActiveEmployee: null,
			suggestionValue: {id: null, name: null},
			isNight: false
    }
  }
  setEmployeeChosen = (val) => {
		if(val.id){
			this.setState({suggestionValue: {id: null, name: null}})
			//dispatch with val to add new employee
			this.props.addEmployee(val)
			return;
		}
		this.setState({suggestionValue: val})
  };
  setIsNight = (bool) => {
		this.setState({
			isNight: bool
		})
  };
  setCurrentActiveEmployee = (employeeId) => {
		this.setState({
			currentActiveEmployee: employeeId===this.state.currentActiveEmployee ? null : employeeId
		})
  };
  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
	};
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentWillUnmount = () => {
		this.props.changeRegistrationDate(new Date());
  };
  shouldButtonsDisable = () => {
		//check if any of the employees are active
		let result = true;
		this.props.employees.forEach((employee) => {
			if (employee.activities.length || employee.absence){
				result = false;
			}
		});
		return result;
  };
  render () {
		const { onClose, routine, employees, setEmployeeIsDragging, setEmployeeHours,
						isResetLoading, attemptSaveRegistration, getEmployeeSuggestions,
						employeeSuggestions, setDroppedEmployee, setEmployeeAbsence,
						registrationDate, changeRegistrationDate, isSavingRegistration,
						employeesIsFetching, draggingEmployee, rmEmployeeFromProject,
						moveEmployee } = this.props;
		var employeeNodes = employees.map((employee, index) => {
			return (
				<div key={employee.id} className="row" style={styles.employeeContainer}>
					<EmployeeDropableSorter
						index={index}
						isLast={false}
						moveEmployee={moveEmployee}
					/>
					<Employee
							key={employee.id}
							routine={routine}
							employee={employee}
							setAsActive={this.setCurrentActiveEmployee}
							isActive={this.state.currentActiveEmployee===employee.id}
							index={index}
							setEmployeeIsDragging={setEmployeeIsDragging}
							setEmployeeHours={setEmployeeHours}
							setDroppedEmployee={setDroppedEmployee}
							isNight={this.state.isNight}
							employeesIsFetching={employeesIsFetching}
							setEmployeeAbsence={setEmployeeAbsence}
					/>
					{index===employees.length-1 ?
						<EmployeeDropableSorter
							index={index}
							isLast={true}
							moveEmployee={moveEmployee}
						/>
						:
						null}
				</div>)
		})

    return (
			<div style={styles.outerContainer}>
				<div style={[styles.sideBarContainer, this.state.isNight && styles.sideBarContainerNight]}>
					<div style={styles.heading}>
						<h2 style={[styles.title, this.state.isNight && styles.titleNight]}>
							Timeregistrering
							<i onClick={onClose} style={styles.closeCross} className="fa fa-times waves-icon" />
						</h2>
						<div className="row" style={styles.registerSettings}>
							<div className="col-xs-12 waves-btn" style={[styles.date, this.state.isNight && styles.dateNight]}>
								<DatepickerSmall defaultValue={registrationDate} onChange={changeRegistrationDate}/>
							</div>
						</div>
						<div className="row" style={styles.nightDayContainer}>
							<button
								className={!this.state.isNight ? "col-xs-6 btn btn-info waves-btn" : "col-xs-6 btn btn-default waves-btn"}
								onClick={() => this.setIsNight(false)}
								style={[styles.DNButton, styles.dayBtn]}>
									<i className="fa fa-sun-o"></i>
							</button>
							<button
								className={!this.state.isNight ? "col-xs-6 btn btn-default waves-btn" : "col-xs-6 btn btn-info waves-btn"}
								onClick={() => this.setIsNight(true)}
								style={[styles.DNButton, styles.nightBtn]}>
									<i className="fa fa-moon-o"></i>
							</button>
						</div>
						<div style={styles.divider} />
					</div>
					<div style={styles.addEmployeeContainer}>
						{draggingEmployee ?
							<EmployeeDropableTrashcan rmEmployeeFromProject={rmEmployeeFromProject} />
							:
							<SuggestSelectInput
								type="text"
								onQuery={getEmployeeSuggestions}
								suggestions={employeeSuggestions}
								placeholder="Tilføj nyt mandskab"
								onChange={this.setEmployeeChosen}
								value={this.state.suggestionValue}
								inputStyle={styles.suggestInput}
								/>
						}
					</div>
					<Scrollbars style={{ width: '100%', height: '100%'}}>
						{employeeNodes}
					</Scrollbars>
					<div style={styles.footer}>
						<div style={styles.divider} />
						<button
							onClick={this.props.attemptResetEmployees}
							disabled={this.shouldButtonsDisable()}
							className={this.shouldButtonsDisable() ? "btn btn-default" : "btn btn-primary waves-btn" }
							style={[styles.footerBtns]}>
								{isResetLoading ? (<i style={styles.resetLoading} className="fa fa-spinner fa-spin"/>) : "Nulstil"}
						</button>
						<button
							className={this.shouldButtonsDisable() ? "btn btn-default" : "btn btn-success waves-btn"}
							onClick={attemptSaveRegistration}
							disabled={this.shouldButtonsDisable()}
							style={[styles.footerBtns, styles.secondFooterBtn]}>
								{isSavingRegistration ? (<i style={styles.resetLoading} className="fa fa-spinner fa-spin"/>) : "Registrer"}
						</button>
					</div>
				</div>
			</div>
    );
  }
}
var styles = {
	addEmployeeContainer: {
		position : 'absolute',
		top: '150px',
		left: '12px',
		right: '12px',
		height: '42px'
	},
	outerContainer: {
		position: 'absolute',
		top: '0',
		right: '0',
		height: '100%',
		paddingTop: '50px',
		width: '25%'
	},
	sideBarContainer: {
		position: 'relative',
		boxShadow: '-3px 5px 16px -2px rgba(0,0,0,0.54)',
		padding: '192px 12px 72px 12px',
		width: '100%',
		height: '100%',
		backgroundColor: semanticColors.default,
		borderRadius: '2px 0 0 2px'
	},
	heading:{
		position: 'absolute',
		top: '0',
		width: '100%',
		borderTop: '1px solid ' + semanticColors.mainBackground,
		left: '0',
		padding: '0 12px',
		borderRadius: '2px'
	},
	sideBarContainerNight: {
		backgroundColor: semanticColors.primaryDark
	},
	suggestInput: {
		height: '42px'
	},
	closeCross: {
		lineHeight: '30px',
    fontSize: '26px',
    width: '30px',
    height: '30px',
    float: 'right'
	},
	title :{
		fontWeight: '500',
		paddingTop: '4px',
		paddingBottom: '8px',
		lineHeight: '30px'
	},
	titleNight: {
		color: semanticColors.default
	},
	registerSettings: {
		margin: '0',
		paddingBottom: '12px'
	},
	nightDayContainer: {
		margin: '0'
	},
	date: {
		padding: '0px 7px 0px 0px',
		lineHeight: '35px'
	},
	dateNight: {
		color: semanticColors.default
	},
	closeButton: {
    cursor: 'pointer',
    color: greyScaleColors.greyDark,
    textAlign:'right',
    fontSize: '26px'
	},
  DNButton:{
		height: '35px',
		fontSize: '20px',
		lineHeight: '1em'
  },
	dayBtn : {
		borderRadius: '2px 0px 0px 2px'
	},
	nightBtn : {
		borderRadius: '0px 2px 2px 0px'
	},
	nightDayActive: {
		backgroundColor: semanticColors.info,
		color: semanticColors.default
	},
	footerBtns: {
		width: '110px',
		float: 'left',
		marginBottom: '12px'
	},
	secondFooterBtn :{
		float: 'right'
	},
	resetLoading:{
		fontSize: '21px'
	},
	divider: {
		margin: '12px 0',
		borderTop: '1px solid ' + semanticColors.mainBackground
	},
	footer: {
		position: 'absolute',
		bottom: '0',
		left: '0',
    width: '100%',
    padding: '0 12px'
	},
	employeeContainer: {
		margin: '0',
		position: 'relative'
	}
}
	SideBar.propTypes = {
		onClose: PropTypes.func.isRequired,
    employees: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      hours: PropTypes.number,
      nightHours: PropTypes.number,
      activities: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.string,
				hours: PropTypes.number
      })).isRequired,
      absence: PropTypes.shape({
				date: PropTypes.object.isRequired,
				hours: PropTypes.number.isRequired,
				absenceCode: PropTypes.string
      })
    })).isRequired,
    routine: PropTypes.number.isRequired,
    setEmployeeIsDragging: PropTypes.func.isRequired,
    setEmployeeHours: PropTypes.func.isRequired,
    isResetLoading: PropTypes.bool.isRequired,
    attemptSaveRegistration: PropTypes.func.isRequired,
    getEmployeeSuggestions: PropTypes.func.isRequired,
    employeeSuggestions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })).isRequired,
    addEmployee: PropTypes.func.isRequired,
    setDroppedEmployee: PropTypes.func.isRequired,
    setEmployeeAbsence: PropTypes.func.isRequired,
    registrationDate: PropTypes.instanceOf(Date).isRequired,
    changeRegistrationDate: PropTypes.func.isRequired,
    isSavingRegistration: PropTypes.bool.isRequired,
    attemptResetEmployees: PropTypes.func.isRequired,
    employeesIsFetching: PropTypes.bool.isRequired,
    draggingEmployee: PropTypes.string,
    moveEmployee: PropTypes.func.isRequired
  };
export default Radium(SideBar)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/Sidebar/index.jsx